import { Navigate, Outlet } from 'react-router-dom';
import Sidebar from '../layout/Sidebar/Sidebar';
import styles from './RequireAuth.module.css';

type RequireAuthProps = {
  isLoggedIn: boolean
}

function RequireAuth(props: RequireAuthProps) {

  if (!props.isLoggedIn) {
    return <Navigate to='/' />;
  }

  return (
    <div className={styles.container}>
      <Sidebar />
      <div style={{ width: '100%' }}>
        <Outlet />
      </div>
    </div>
  );
}

export default RequireAuth;
